export enum FiledKey {
    NAME = 'orgName',
    DATE = 'crtTime',
    STATE = 'status',
    INDEX = 'index',
    REASON = 'cancelReason',
    BZ = 'bz'
}

const State: Record<string, any> = {
    '0': '受理中',
    '1': '受理中',
    '2': '已通过',
    '3': '未通过'
};

export const columns = [
    {
        title: '序号',
        width: '6%',
        filed: FiledKey.INDEX
    },
    {
        title: '医疗机构名称',
        width: '24%',
        filed: FiledKey.NAME
    },
    {
        title: '申请时间',
        width: '16%',
        filed: FiledKey.DATE
    },
    {
        title: '状态',
        width: '8%',
        filed: FiledKey.STATE,
        format: (text?: string) => {
            if (text) return State[text];
            return text;
        }
    },
    {
        title: '理由',
        width: '26%',
        filed: FiledKey.REASON
    },
    {
        title: '操作',
        width: '20%',
        filed: FiledKey.BZ
    }
];
